(function () {
  if (window.__ksProductBundlerLoader) return;
  window.__ksProductBundlerLoader = true;

  var READY_SELECTOR = '.rebuy-bundle-builder, .rebuy-bundle-builder__main, .rebuy-widget-content';
  var FALLBACK_MS = 45000;

  function getWidgetId(root) {
    var placeholder = root.querySelector('[data-rebuy-id]');
    if (!placeholder) return null;
    var id = placeholder.getAttribute('data-rebuy-id');
    return id && id.trim() ? id.trim() : null;
  }

  function isWidgetReady(widgetId) {
    var widget = document.getElementById('rebuy-widget-' + widgetId);
    if (!widget) return false;
    return !!widget.querySelector(READY_SELECTOR);
  }

  function markReady(root) {
    if (!root || !root.classList.contains('is-loading')) return;

    root.classList.remove('is-loading');

    var loader = root.querySelector('[data-ks-product-bundler-loader]');
    if (loader) {
      loader.setAttribute('aria-busy', 'false');
      loader.hidden = true;
    }
  }

  function initRoot(root) {
    var widgetId = getWidgetId(root);
    if (!widgetId) return;

    if (isWidgetReady(widgetId)) {
      markReady(root);
      return;
    }

    var disconnected = false;
    var observer = new MutationObserver(function () {
      if (disconnected) return;
      if (isWidgetReady(widgetId)) {
        disconnected = true;
        observer.disconnect();
        markReady(root);
      }
    });

    var placeholder = root.querySelector('[data-rebuy-id]');
    if (placeholder) {
      observer.observe(placeholder, { childList: true, subtree: true });
    }

    observer.observe(document.body, { childList: true, subtree: true });

    window.setTimeout(function () {
      if (disconnected) return;
      disconnected = true;
      observer.disconnect();
      markReady(root);
    }, FALLBACK_MS);
  }

  function boot() {
    document.querySelectorAll('[data-ks-product-bundler]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
